/**
 * @author        quanquan
 * @dateTime      2021-01-04 10:07:48
 * @description   Authority
 */

import MC from '@/module/MC'
import { routes } from '@/conf/home/router'
import { isParams } from '@/module/layout/_source/utils'
import { appInfos } from '@/module/singleSpa/appInfos'

const handlerRouter = (routes, system) => {
  return _.map(routes, v => {
    return {
      ..._.omit(v, ['component']),
      system,
      children: _.isEmpty(v.children) ? [] : handlerRouter(v.children, system)
    }
  })
}

// 平安项目只部署  commodity  cloud merchant三个子项目
class Ps {
  constructor () {
    if (process.env.NODE_ENV === 'production') {
      this.$allRouter = {
        merchant: merchant.router,
        cloud: cloud.router,
        commodity: commodity.router,
        app: []
      }
      this.routerIgnore = {
        cloudIgnoreMenuPath: cloud.cloudIgnoreMenuPath,
        merchantIgnoreMenuPath: merchant.merchantIgnoreMenuPath,
        commodityIgnoreMenuPath: commodity.commodityIgnoreMenuPath
      }
      this.ignoreBackage = []
    } else {
      this.$allRouter = _.pick(allRouter, [
        // 'medical',
        // 'hdsec',
        'merchant',
        'cloud',
        // 'honey',
        'commodity',
        // 'marketing',
        'app'
      ])
      this.routerIgnore = allRouter.ignore
      this.ignoreBackage = allRouter.ignoreBackage
      console.log(this.$allRouter, this.routerIgnore, this.ignoreBackage)
      console.log(this.$allRouter, this.routerIgnore, this.ignoreBackage)
    }
  }

  /**
       * Permission processing
       *
       * @param {String|Boolean} path
       * @param {String} system
       * @returns {Boolean} Return to permission status
       */
  isAuth ({ path, system }) {
    if (_.isEmpty(system) || _.isEmpty(path)) {
      console.error('Error no system mark or route path')
      return false
    }
    const item = this.getRouteItem({ path, system })

    // no auth
    if (!_.isObject(item)) {
      return false
    }
    const { auth } = item.meta

    return _.isBoolean(auth) ? auth : !MC.get(auth)
  }

  /**
       * Get route item
       *
       * @param {String} path router path
       * @param {String} system
       * @returns {Object|Boolean} Return route object
       */
  getRouteItem ({ path, system }) {
    if (system === 'app' && _.isEmpty(this.$allRouter[system])) {
      this.$allRouter.app = handlerRouter(routes, 'app')
    }
    const curSystemRouter = this.$allRouter[system]
    const item = { }
    const pQuery = { }
    const recursion = routes => {
      _.map(routes, v => {
        const o = isParams(v.path, path)
        if (v.path === path || _.isObject(o)) {
          _.assign(pQuery, o)
          _.assign(item, v)
        } else {
            _.isEmpty(v.children)? '' : recursion(v.children)  // eslint-disable-line
        }
      })
    }
    recursion(curSystemRouter)

    console.log('[App VueRouter] => 子系统路由数据 ', curSystemRouter)
    return _.isEmpty(item) ? { } : { ...item, pQuery }
  }

  /**
       * Resolve path
       *
       * @param {Object} route
       * @return {Object} system|path
       */
  handlerPath (route) {
    const path = route.path
    const systemList = _.map(appInfos, 'name')
    const system = _.split(path, '/')[1]
    const isSystem = systemList.includes(system)
    return {
      system: isSystem ? system : 'app',
      path: isSystem ? path.replace(`/${system}`, '') : path
    }
  }

  /**
       * Handler path parameters turn string splicing
       *
       * @param {Object} query
       * @return {String} Return the concatenated string parameters
       */
  handlerQuery (query, isVal = false) {
    let str = '?'
    let strVal = ''
    _.map(query, (v, i) => {
      str += `${i}=${v}&`
      strVal += `${v}`
    })
    return isVal
      ? _.isEmpty(query)
        ? ''
        : strVal
      : _.isEmpty(query)
        ? ''
        : _.trimEnd(str, '&')
  }

  /**
       * Get all routers
       *
       * @returns {Object} Return to all routes for other development to make it smarter
       */
  getRoutes () {
    return this.$allRouter
  }
}

export default new Ps()



// WEBPACK FOOTER //
// ./src/js/module/ps/index.js